import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { WishlistService } from '../../../../services/raintree/Transmission/wishlist.service';
import { LoaderComponent } from '../../../../common-component/loader/loader.component';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-inactive-dialog',
  standalone: true,
  imports: [MatDialogModule, LoaderComponent],
  templateUrl: './inactive-dialog.component.html',
  styleUrl: './inactive-dialog.component.scss'
})
export class InactiveDialogComponent implements OnInit{
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<InactiveDialogComponent>,
    private _wishlistService: WishlistService,
    private toaster: ToastrService
    
  ) { }

  isLoading: boolean = false

  ngOnInit(): void {
    console.log(this.data, 'inactive');
    
  }

  oncancel() {
    this.dialogRef.close(false);
  }

  onInactiveClick(){
    const SL_NO = this.data.SL_NO || this.data.slno
    this.isLoading = true
    this._wishlistService.inactiveWishlistItem(SL_NO).subscribe({
      next: (res) => {
        if(res){
          this.isLoading = false;
          this.toaster.success(res.message)
          this.dialogRef.close(true);
        }
      },error: (err) => {
          this.isLoading = false;
        this.toaster.error(err)
      }
    })
  }
}
